import React from "react"
import { Seo } from './seo'
import Nav from './nav'
import Footer from './footer'

const Layout = ({ pageTitle, children, hideHeader, hideFooter }) => {
    return (
        <>
            <Seo title={pageTitle} />
            <div className="antialiased bg-body text-body font-body">
                <title>{pageTitle}</title>

                <div>
                    {hideHeader !== "true" && <Nav />}

                    {children}
                    {hideFooter !== "true" && <Footer />}
                </div>
            </div>
        </>
    )
}

export default Layout